import React, { useState } from "react";
import ButtonNavigatorComponent from "../../../components/ButtonNavigator";
import IconButton from "../../../components/IconButton";
import { TableComponent, TH, THeadTR } from "../../../components/Table v2";
import { IconAdd, IconEye } from "../../../icons";
import { ITableInvoice } from "../models";

export function TableInvoice({ invoices, handleFileClick }: ITableInvoice) {
  const [page, setPage] = useState(1);
  const [selectSize, setSelectSize] = useState(10);

  const listRenderObserverThePage = (indexOfLine: number) => {
    const initialListRender = indexOfLine < (page + 1) * selectSize;
    const endListRender = indexOfLine >= page * selectSize;
    return initialListRender && endListRender;
  };

  return (
    <div>
      <TableComponent>
        <THeadTR>
          <TH>Período</TH>
          <TH>Valor da Nota Fiscal</TH>
          <TH>
            {" "}
            <span className="justify-center"> Horas Trabalhadas</span>
          </TH>
          <TH>Ver Nota Fiscal</TH>
          <TH>Adicionar Nota Fiscal</TH>
        </THeadTR>
        <tbody>
          {invoices?.map((data, index) => {
            const firstDayOfMonth = new Date(+data?.year, +data?.month - 1, 1)?.toLocaleDateString();
            const lastDayOfMonth = new Date(+data?.year, +data?.month, 0)?.toLocaleDateString();

            return (
              listRenderObserverThePage(index) && (
                <tr className="border-b-2 border-background">
                  <td>
                    {firstDayOfMonth} até {lastDayOfMonth}
                  </td>
                  <td>{data?.value?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                  <td className="text-center">{data?.timeApproved} {data?.timeApproved ? 'hrs' : ''}</td>
                  <td>
                    {data?.invoice ? (
                      <a href={data?.invoice} target="_blank">
                        <IconButton icon={IconEye} className="justify-center text-primary" />
                      </a>
                    ) : (
                      <IconButton icon={IconEye} className="justify-center text-gray-700 disabled-icon" />
                    )}
                  </td>
                  <td>
                    <label className="input-type-file cursor-pointer">
                      <input
                        type="file"
                        onChange={(e) => handleFileClick(e.target, { year: data.year, month: data.month })}
                        accept="application/pdf"
                      />
                      <IconButton icon={IconAdd} className="justify-center icon-add" />
                    </label>
                  </td>
                </tr>
              )
            );
          })}
        </tbody>
      </TableComponent>
      <ButtonNavigatorComponent list={invoices} page={page} setPage={setPage} selectSize={selectSize} setSelectSize={setSelectSize} />
    </div>
  );
}
